export default "__VITE_ASSET__DWIW0IPs__"